import { useState, useEffect, useRef } from 'react';
import { FiSearch, FiChevronDown, FiCheckCircle } from 'react-icons/fi';
import styles from './OfferingsPage.module.css';

export default function OfferingsCategorySelect({ value, displayValue, options, onSelect, rowIndex, totalRows, panelStyle }) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const ref = useRef(null);

  // Open upward for the last two rows to avoid clipping
  const openUp = rowIndex >= totalRows - 2 && totalRows > 2;

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const filtered = options.filter((o) =>
    (o.name || '').toLowerCase().includes((query || '').toLowerCase())
  );

  return (
    <div ref={ref} className={styles.catSelectWrap}>
      <div
        className={`${styles.catSelectTrigger} ${open ? styles.open : ''}`}
        onClick={() => setOpen((o) => !o)}
      >
        {value
          ? <span className={styles.catSelectValue}>{displayValue}</span>
          : <span className={styles.placeholder}>Select category…</span>}
        <FiChevronDown size={13} className={`${styles.chevron} ${open ? styles.rotate : ''}`} />
      </div>

      {open && (
        <div className={`${styles.catDropdown} ${openUp ? styles.dropUp : ''}`} style={panelStyle}>
          <div className={styles.catDropdownSearch}>
            <FiSearch size={12} className={styles.catDropdownSearchIcon} />
            <input
              autoFocus
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              className={styles.catDropdownSearchInput}
              placeholder="Search…"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <div className={styles.catDropdownList}>
            {filtered.length === 0 ? (
              <div className={styles.dropdownEmpty}>No categories</div>
            ) : (
              filtered.map((o) => (
                <div
                  key={o.id}
                  className={`${styles.catDropdownItem} ${o.id === value ? styles.active : ''} ${o.disabled ? styles.catDropdownItemDisabled : ''}`}
                  aria-disabled={o.disabled ? 'true' : undefined}
                  onClick={() => {
                    if (o.disabled) return;
                    onSelect(o);
                    setOpen(false);
                    setQuery('');
                  }}
                >
                  <span>{o.name}</span>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 6, marginLeft: 'auto' }}>
                    {o.badge && (
                      <span className={styles.catBadge}>{o.badge}</span>
                    )}
                    {o.id === value && (
                      <FiCheckCircle size={12} style={{ color: 'var(--color-primary)' }} />
                    )}
                  </span>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
}
